"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = exports.enhanceRow = exports.preview2D3DCell = void 0;
var React = require("react");
var components_1 = require("components");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FileIcon_1 = require("components/FileIcon");
var preview_1 = require("utils/preview");
var useCustomMeta_1 = require("../../ReliablePartner/hook/useCustomMeta");
var preview2D3DCell = function (file, baseUrl, token, convert, navigateTo, section) {
    var clickAction = function () {
        if (file.type !== 'FOLDER') {
            if (!file.preview || file.preview.status !== 'PROCESSED') {
                convert(file);
            }
            else {
                navigateTo(baseUrl + "/preview/".concat(file.fileUuid, "/revision/").concat(file.uuid));
            }
        }
    };
    switch (file.type) {
        case 'DWG':
            return (React.createElement("div", { className: "row__column upload info icon narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, file.preview && file.preview.status === 'PROCESSING'
                        ? (0, translation_1.getLocalization)('fileslist/listrow/dwg/pleaseWait')
                        : file.preview && file.preview.status === 'PROCESSED'
                            ? (0, translation_1.getLocalization)('fileslist/listrow/dwg/openViewer')
                            : (0, translation_1.getLocalization)('fileslist/listrow/dwg/export')) },
                    React.createElement(components_1.TableRowIcon, { icon: file.preview && file.preview.status === 'PROCESSING'
                            ? 'sok-icon-3d-orange'
                            : file.preview && file.preview.status === 'PROCESSED'
                                ? 'sok-icon-2d-green'
                                : 'sok-icon-2d-pink', onClick: clickAction }))));
        case 'IFC':
            return (React.createElement("div", { className: "row__column upload info icon narrow" },
                React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, file.preview && file.preview.status === 'PROCESSING'
                        ? (0, translation_1.getLocalization)('fileslist/listrow/bim/pleaseWait')
                        : file.preview && file.preview.status === 'PROCESSED'
                            ? (0, translation_1.getLocalization)('fileslist/listrow/bim/openViewer')
                            : (0, translation_1.getLocalization)('fileslist/listrow/bim/export')) },
                    React.createElement(components_1.TableRowIcon, { icon: file.preview && file.preview.status === 'PROCESSING'
                            ? 'sok-icon-3d-orange'
                            : file.preview && file.preview.status === 'PROCESSED'
                                ? 'sok-icon-3d-green'
                                : 'sok-icon-3d-pink', onClick: clickAction }))));
        case 'PDF':
            return (React.createElement("div", { className: "row__column external_link info icon narrow" }, file.type === 'PDF' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('fileslist/listrow/openToNotWindow')) },
                React.createElement("a", { target: '_blank', href: (0, preview_1.createLink)(file, baseUrl, true, token, section) },
                    React.createElement(components_1.TableRowIcon, { className: 'blue', icon: 'fa-external-link' })))) : null));
        default:
            return React.createElement("div", { className: "row__column upload info narrow" });
    }
};
exports.preview2D3DCell = preview2D3DCell;
exports.enhanceRow = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    var index = nextProps.index, data = nextProps.data;
    var oldData = props.data;
    var file = data.items[index];
    if (data.itemSelections[file.uuid] !== oldData.itemSelections[file.uuid]) {
        return true;
    }
    if (file.bookmarked !== oldData.items[index].bookmarked) {
        return true;
    }
    if (data.columns !== oldData.columns) {
        return true;
    }
    if (file.preview &&
        oldData.items[index].preview &&
        file.preview.status !== oldData.items[index].preview.status) {
        return true;
    }
    if (props.style !== nextProps.style) {
        return true;
    }
    if (data.items[index] !== oldData.items[index]) {
        return true;
    }
    return false;
}));
var ListRow = function (section) {
    return (0, exports.enhanceRow)(React.memo(function (_a) {
        var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
        var isMobile = data.isMobile, items = data.items, columns = data.columns, baseUrl = data.baseUrl, itemSelections = data.itemSelections, downloadFolder = data.downloadFolder, toggleItem = data.toggleItem, token = data.token;
        var file = items[index];
        var selected = itemSelections[file.uuid];
        var downloadLinkUrl = "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid);
        var url = baseUrl.replace(/\/[^\/]*$/, '/' + file.parent);
        var renderCustomMeta = (0, useCustomMeta_1.useCustomMeta)(columns, file, baseUrl, isMobile, token, section);
        return (React.createElement("div", { className: className + ' ' + (file.type !== 'FOLDER' ? 'file' : ''), style: style },
            React.createElement("div", { className: "row__column first narrow icon" },
                React.createElement("div", { className: 'file-icon' }, (0, FileIcon_1.typeToIconAndTextMap)(file.type).icon)),
            React.createElement("div", { className: "row__column narrow" },
                React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, className: selected ? 'selected' : null, onClick: function (e) {
                        e.stopPropagation();
                        toggleItem(file);
                    } })),
            React.createElement("div", { className: 'row__column narrow download icon' }, file.type === 'FOLDER' ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFolder')) },
                React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center', onClick: function () {
                        downloadFolder(file);
                    } }))) : (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/toolTip/downloadFile')) },
                React.createElement("a", { href: downloadLinkUrl, target: "_blank" },
                    React.createElement(sok_ui_1.Icon, { className: 'sok-icon-download-cloud sok-icon-download-cloud-center' }))))),
            renderCustomMeta));
    }, function (nextProps, props) {
        if (nextProps.data !== props.data) {
            return false;
        }
        return true;
    }));
};
exports.ListRow = ListRow;
